
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface PrinterSettingsDsParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface PrinterSettingsDS {
  Id?:number;
  printersettingsid:number;
  dstitle:string;
  dssignedpersonname:string;
  dsfilename:string;
  dslocation:string;
  containername:string;
  dstype:string;
  dsreftable:string;
  dsrefid:any;
  dspage:string;
  CreatedBy:string;
  CreatedDate:Date;
  modifiedby:string;
  modifieddate:Date;
  BranchId:any;
  TenantId:any;
  isEdit:boolean,
  isCreate:boolean,
  dsSubTitle?:string,
  dsSigOrder?:string
}

export interface TypeOptions {    
    title: string;
}

export class psDatas {

    public static doctorPages:any=[
      "Prescription",
      "Daycare Summary",
      "Discharge Summary",
      "Case Sheet Summary",
      "Medical Certificate",
      "List"
    ]
    public static employeePages:any=[
      "Lab Result",
      "Radiology Result"
    ]   
}
  
export abstract class PrinterSettingsDSData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<PrinterSettingsDS[]>;
  abstract create(url: string,data: any): Observable<PrinterSettingsDS>;
  abstract update(url: string,data: any): Observable<PrinterSettingsDS>;
  abstract delete(url: string): Observable<boolean>;
}
